import { Expose } from "class-transformer";

export class SendOnboardingInvitationDto {
  @Expose()
  theoreticalPosition?: string;

  @Expose()
  firstName?: string;

  @Expose()
  lastName?: string;

  @Expose()
  dni?: string;
}
